/** @jsx jsx */
import React, { useContext, Fragment, useRef } from "react";
import { Link } from "gatsby";
import { MenuContext } from "@/context/menu-context";
import { Col, Container, Row } from "react-bootstrap";
import { LogoFooterImage, NavLinks, SupportImage, NavInnerLinks } from "@/data";
import { jsx } from "@emotion/react";
import Instagram from "../assets/icons/instagram-icon.svg";
import Facebook from "../assets/icons/facebook-icon.svg";
import Youtube from "../assets/icons/youtube-icon.svg";
import MapLocationIcon from '../assets/icons/mapLocation-icon.svg'

import {
  showOverlayNav,
  popUpMenu,
  closepopUp,
  footerContacts,
  popUpSocial,
  logo2,
  popUpInner,
  dlMenuWrap,
  subMenu,
  popUp,
  org,
  socialMedia,
  top_city
} from "../assets/styles/PopUpMenu.styles";

const PopupMenu = () => {
  const { menuStatus, updateMenuStatus } = useContext(MenuContext);
  const menuEl = useRef(null);
  const handleMenuClick = (e) => {
    e.preventDefault();
    updateMenuStatus(!menuStatus);
  };
  const handleMenuMobClick = () => {
    updateMenuStatus(!menuStatus);
  };
  return (
    <div className="show-overlay-nav" css={showOverlayNav}>
      <div className="popup popup__menu" css={[popUp, popUpMenu]}>
        <a
          href=""
          id="close-popup"
          onClick={handleMenuClick}
          css={closepopUp}
        ></a>
        <div className="container mobileContainer">
          <div className="row">
            <div className="col-lg-12 text-left">
              <div css={logo2}>
                <Link to="/">
                  <img src={LogoFooterImage.light} alt="" />
                </Link>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-12">
              <div css={popUpInner} className="popup-inner">
                <nav
                  css={dlMenuWrap}
                  className="popup-menu dl-menu__wrap text-center"
                  ref={menuEl}
                >
                  <ul style={{ marginTop: '119px' }}>
                    {NavInnerLinks.map((links, index) => {
                      return (
                        <li
                          key={index}
                          className={`${undefined !== links.subItems
                            ? "menu-item-has-children"
                            : ""
                            }`}
                        >
                          <Link to={links.url} onClick={handleMenuMobClick}>
                            {links.name}
                          </Link>
                          {undefined !== links.subItems ? (
                            <Fragment>
                              <button
                                className='expand_button'
                                onClick={(e) => {
                                  menuEl.current
                                    .querySelectorAll(".sub-menu")
                                    .forEach((item) => {
                                      item.classList.remove("show");
                                    });

                                  let clickedItem = e.currentTarget.parentNode;
                                  clickedItem
                                    .querySelector(".sub-menu")
                                    .classList.toggle("show");
                                }}
                              >
                                <i><svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
                                  <path d="M10.2441 16.5703H22.8897" stroke="#9873FF" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" />
                                  <path d="M16.5664 10.25L16.5664 22.8955" stroke="#9873FF" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" />
                                  <path d="M16.5733 29.1467C23.5174 29.1467 29.1467 23.5174 29.1467 16.5733C29.1467 9.62927 23.5174 4 16.5733 4C9.62927 4 4 9.62927 4 16.5733C4 23.5174 9.62927 29.1467 16.5733 29.1467Z" stroke="#9873FF" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" />
                                </svg></i>
                              </button>
                              <ul css={subMenu} className="sub-menu">
                                {links.subItems.map((subLinks, index) => (
                                  <li key={index}>
                                    <Link
                                      style={{
                                        fontWeight: 500, fontSize: '14px', color: '#9873FF'
                                      }}
                                      to={subLinks.url}>
                                      {subLinks.name}
                                    </Link>
                                  </li>
                                ))}
                              </ul>
                            </Fragment>
                          ) : null}
                        </li>
                      );
                    })}
                  </ul>
                </nav>
                <div css={socialMedia}>
                  <div css={top_city}>
                    <img src={MapLocationIcon} />
                    <span>Brasília - DF | Lago Sul</span>
                  </div>
                  <nav className='nav-social'>
                    <a target='_blank' href='https://www.instagram.com/kingdomschooloficial/'>
                      <img src={Instagram} alt="Instagram" />
                    </a>
                    <a target='_blank' href='https://www.facebook.com/kingdomschooldf'>
                      <img src={Facebook} alt="Facebook" />
                    </a>
                    <a target='_blank' href='https://www.youtube.com/@KingdomSchool.Oficial'>
                      <img src={Youtube} alt="Youtube" />
                    </a>
                  </nav>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PopupMenu;
